import { Input, Directive, ElementRef, HostListener } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
    selector: `[ngModel][appPhoneMask]`,
    providers: [NgModel]
})
export class PhoneMaskDirective {
    constructor(private model: NgModel) { }

    @HostListener('ngModelChange', ['$event'])
    onModelChange(event) {
        console.log('eventttt '+event);
        this.onInputChange(event, false);
    }

    @HostListener('keydown.backspace', ['$event'])
    keydownBackspace(event) {
        console.log('backspace '+event);
        this.onInputChange(event.target.value, true);
    }


    onInputChange(event, backspace) {
        let newVal = event.replace(/\D/g, '');
        console.log('beginning '+event);

        if (backspace && newVal.length <= 6) {
            newVal = newVal.substring(0, newVal.length - 1);
        } 

        if (newVal.length === 0) {
            newVal = ' ';
        } else if (newVal.length <= 3) {
            newVal = newVal.replace(/^(\d{0,3})/, '($1)');
        } else if (newVal.length <= 6) {
            newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
        } else if (newVal.length <= 10) {
            newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
        } else {
            newVal = newVal.substring(0, 10);
            newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
        }
        console.log('end '+newVal);
        this.model.valueAccessor.writeValue(newVal);
    }
}
